import MarkdownEditor, { MarkdownEditorProps } from '@e3dc-react/shell/Elements/MarkdownEditor/MarkdownEditor'
import React, { forwardRef, useMemo } from 'react'
import { useField, useFormikContext } from 'formik'

interface LocalProps extends Partial<MarkdownEditorProps> {
  name: string
}

/**
 * This component gives opportunity for using Markdown Editor inside Formik forms
 */
const TextEditor = forwardRef<typeof MarkdownEditor, LocalProps>((props, _ref) => {
  const { setFieldValue } = useFormikContext()
  const [field, meta] = useField(props.name as string)

  const hasError = useMemo<boolean>(
    () => {
      return Boolean(meta.error && (meta.initialValue !== meta.value || meta.touched))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.name, meta]
  )

  const handleValue = (value: string): void => {
    setFieldValue(field.name, value)
  }

  return <MarkdownEditor {...props} value={field.value} onChange={handleValue} error={hasError} helperText={hasError ? meta.error : undefined} />
})

TextEditor.displayName = 'TextEditor'

export default TextEditor
